
import { Component, Watch } from 'vue-property-decorator';
import Vue from 'vue';
import { 提示状态, 提示类型 } from '@/store/notifyState';

@Component
export default class Notify extends Vue {
    processing = false;
    timeoutId = 0;

    get items() {
        return 提示状态.提示表;
    }

    @Watch('items')
    processItems() {
        this.processing = true;
        if (this.items && this.items.length > 0) {
            const item = this.items[0];
            return (this.timeoutId = window.setTimeout(() => {
                this.removeItem(item.标识);
            }, 5000));
        }
        this.processing = false;
    }

    removeItem(标识: string) {
        clearTimeout(this.timeoutId);
        提示状态.去除提示(标识);
        if (this.items.length > 0) {
            return this.processItems();
        }
    }

    color(类型: 提示类型) {
        switch (类型) {
            case '信息':
                return 'primary';
            case '成功':
                return 'success';
            case '警告':
                return 'warning';
            case '错误':
                return 'error';
            default:
                return 'primary';
        }
    }
}
